import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './index.css';

const PastHighlights = () => {
  // 这里放置你的Past Highlights图片
  // 请替换成实际的图片路径
  const highlights = [
    require('../../assets/highlights-1.jpg'),
    require('../../assets/highlights-2.jpg'),
    require('../../assets/highlights-3.jpg'),
    require('../../assets/highlights-4.jpg'),
    require('../../assets/highlights-5.jpg'),
    require('../../assets/highlights-6.jpg'),
    require('../../assets/highlights-7.jpg'),
    require('../../assets/highlights-8.png'),
    require('../../assets/highlights-9.jpg'),
    require('../../assets/highlights-10.jpg'),
    require('../../assets/highlights-11.jpg'),
    require('../../assets/highlights-12.jpg'),
    require('../../assets/highlights-13.jpg'),
  ];

  return (
    <div className="past-highlights-wrapper">
      {/* <h2 className="highlights-title">Past Highlights</h2> */}
      <div className="past-highlights-container">
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={3}
          spaceBetween={30}
          loop={true}
          centeredSlides={false}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={1000}
          pagination={{
            el: '.highlights-pagination',
            clickable: true,
            bulletClass: 'highlights-bullet',
            bulletActiveClass: 'highlights-bullet-active'
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 25
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }}
        >
          {highlights.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="highlight-image-wrapper">
                <img
                  src={img}
                  alt={`Past Highlight ${index + 1}`}
                  className="highlight-image"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="highlights-pagination"></div>
      </div>
    </div>
  );
};

export default PastHighlights;
